import * as Constants from '@/lib/constants'

export default {
  methods: {
    createMapGaugeOption(opts, minValue, maxValue, stageCount) {
      opts.yAxis.min = Math.round(minValue * 1000) / 1000
      opts.yAxis.max = Math.round(maxValue * 1000) / 1000
      const step = Math.round(((maxValue - minValue) / stageCount) * 1000) / 1000
      opts.yAxis.interval = step

      let series = []
      minValue = Math.round(minValue * 1000) / 1000
      maxValue = Math.round(maxValue * 1000) / 1000
      if (maxValue <= 0) {
        // maxがマイナスの場合は反転
        for (let i = stageCount - 1; i >= 0; i--) {
          const gaugeColor = Constants.TRACK_COLORS[i]
          let ser = {
            type: 'bar',
            stack: 'gaugeStack',
            itemStyle: { color: gaugeColor },
          }
          if (i === stageCount - 1) {
            ser.data = [maxValue - step]
          } else {
            ser.data = [step * -1]
          }
          series.push(ser)
        }
      } else {
        if (minValue <= 0) {
          // minだけマイナスの場合は両方向から
          let minusCnt = 0
          let stepWk = minValue + step

          while (stepWk < 0) {
            stepWk = stepWk + step

            minusCnt++
          }

          let overWk = 0
          for (let i = minusCnt - 1; i >= 0; i--) {
            const gaugeColor = Constants.TRACK_COLORS[i]
            let ser = {
              type: 'bar',
              stack: 'gaugeStack',
              itemStyle: { color: gaugeColor },
            }
            if (i === minusCnt - 1) {
// TEMP               console.log(minValue + step)
              ser.data = [minValue]
              if (minValue + step < 0) {
                let ser2 = {
                  type: 'bar',
                  stack: 'gaugeStack',
                  itemStyle: { color: Constants.TRACK_COLORS[i + 1] },
                }
                ser2.data = [minValue + step]
                series.push(ser2)
                overWk = Math.round(stepWk * 1000) / 1000
              }
            } else {
              ser.data = [step * -1]
            }

            series.push(ser)
          }

          for (let i = minusCnt; i < stageCount; i++) {
            const gaugeColor = Constants.TRACK_COLORS[i]
            let ser = {
              type: 'bar',
              stack: 'gaugeStack',
              itemStyle: { color: gaugeColor },
            }
            if (i === 0) {
              let stepWk = step + minValue

              if (minValue + step > 0) {
                let ser2 = {
                  type: 'bar',
                  stack: 'gaugeStack',
                  itemStyle: { color: gaugeColor },
                }
                ser2.data = [minValue]
                series.push(ser2)
                stepWk = Math.round(stepWk * 1000) / 1000
              }
              ser.data = [stepWk]
            } else {
              stepWk = step
              if (overWk != 0) {
                stepWk = overWk
                overWk = 0
              }
              ser.data = [stepWk]
            }
            series.push(ser)
          }
        } else {
          for (let i = 0; i < stageCount; i++) {
            const gaugeColor = Constants.TRACK_COLORS[i]
            let ser = {
              type: 'bar',
              stack: 'gaugeStack',
              itemStyle: { color: gaugeColor },
            }
            if (i === 0) {
              ser.data = [step + minValue]
            } else {
              ser.data = [step]
            }
            series.push(ser)
          }
        }
      }

      opts.series = series
      return opts
    },
  },
}
